module.exports = "<!-- Componente invisível - Widget Messenger é gerenciado via JavaScript -->\n<div style=\"display: none;\" aria-hidden=\"true\"></div>\n\n"